export default __webpack_public_path__ + "static/media/kaithero.5520e55a.svg";